import React from "react";

function FacebookButtonComponent() {
    return (
        <div className="fb-like" data-href="https://www.facebook.com/TendreConception" data-width=""
     data-layout="box_count" data-action="like" data-size="large" data-share="true"></div>
    )
}

export default FacebookButtonComponent;